import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const state = {
    product: {
        product_name: null,
    },
    productList: [],
    loading: true,
};

const getters = {
    product: state => state.product,

    productList: state => state.productList,

    loading: state => state.loading,
};

const mutations = {
    setProduct(state, data) {
        state.product = data;
    },

    setProductList(state, data) {
        state.productList = data;
    },

    setLoading(state, data) {
        state.loading = data;
    },

    setEmptyProductList(state) {
        state.productList = [];
    },
};

const actions = {
    async getProductList({ commit, dispatch }, params = {}) {
        const url = Laroute.route('inventory.product.selector');

        const options = {
            params: Object.assign(
                {
                    query: null,
                    limit: 15,
                },
                params,
            ),
        };

        startLoading(dispatch, 'fetch-products');

        try {
            const { data } = await axios.get(url, options);
            let res = data.data;

            endLoading(dispatch, 'fetch-products');
            commit('setProductList', res);
            commit('setLoading', false);

            return data;
        } catch (e) {
            endLoading(dispatch, 'fetch-products');
            throw e;
        }
    },

    emptyProductList({ commit }, params) {
        commit('setEmptyProductList');
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/inventory-product.js